// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UCOZ","right":"styles_right__16ZQd"};